const {trackComponentDisplayedEvent} = require('od-modules/track_events/track.frontevents.utils');
const getResponseData = (response) => Odigeo._.isObject(response) && Odigeo._.isObject(response.attributes)
    ? response.attributes
    : response;

const isResponseOK = (data) => data === true || (Odigeo._.isObject(data) && data.responseOK);

const getHandlersByName = (items = [], methodName) => items.map((item) => item[methodName] || (() => {}));

class AncillariesLoaderBase {
    constructor({service, action, subscribers = [], resolve = () => {}, reject = () => {}}) {
        this.service = service;
        this.action = action;
        this.subscribers = subscribers;
        this.resolve = resolve;
        this.reject = reject;
    }

    load(bookingInfo) {

    }

    onDataReceived(data = {}) {
        const response = getResponseData(data);
        return isResponseOK(response) ? this.onSuccess(data) : this.onError(data);
    }

    onSuccess(data = {}) {
        getHandlersByName(this.subscribers, 'success').map((handler) => handler(data));
        this.resolve(data);
    }

    onError(data = {}) {
        const response = getHandlersByName(this.subscribers, 'failure').map((handler) => handler(data));
        if (!response.some((result) => result === true)) {
            trackComponentDisplayedEvent('checkin-funnel-error-modal')
                .then(() => this.reject(data))
                .catch(() => this.reject(data));
        }
    }
}

module.exports = AncillariesLoaderBase;
